export function SkeletonBlock({ className = "" }) {
  return <div className={`animate-pulse rounded-lg bg-white/[0.05] ${className}`} />;
}

export function StatCardSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4" data-testid="skeleton-stats">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-white/[0.06] bg-[#141414] p-6">
          <SkeletonBlock className="h-3 w-24" />
          <SkeletonBlock className="mt-4 h-8 w-16" />
          <SkeletonBlock className="mt-3 h-2 w-20" />
        </div>
      ))}
    </div>
  );
}

export function TableSkeleton({ rows = 6, cols = 5 }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-white/[0.06] bg-[#141414]" data-testid="skeleton-table">
      <div className="flex gap-4 border-b border-white/[0.06] px-6 py-4">
        {Array.from({ length: cols }).map((_, i) => (<SkeletonBlock key={i} className="h-3 flex-1" />))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4 border-b border-white/[0.04] px-6 py-4">
          {Array.from({ length: cols }).map((_, c) => (<SkeletonBlock key={c} className="h-4 flex-1" />))}
        </div>
      ))}
    </div>
  );
}
